class ClientsController {
    init() {

    }

    index() {
        // Table sorting and pagination now handled by Stimulus table controller
    }

    comments() {
        // Table sorting and pagination now handled by Stimulus table controller
    }

    show() {

    }

    edit() {
        clientsOnEditOrNew();
    }

    new() {
        clientsOnEditOrNew();
    }

    todo() {
        addOrRemoveFields();
    }
}

window.BC = window.BC || {};
window.BC.clients = new ClientsController();

function clientsOnEditOrNew() {
    let filters = ["show-completed"];
    for (let i = 0; i < filters.length; i++) {
        let filter = filters[i];
        let elements = document.querySelectorAll("." + filter);
        
        elements.forEach(element => {
            if (getCookie(filter) === "true") {
                element.checked = true;
            } else {
                element.checked = false;
                document.querySelectorAll('.completed-task').forEach(task => {
                    task.style.display = 'none';
                });
            }
            
            element.addEventListener('click', function() {
                if (this.checked) {
                    setCookie(filter, true);
                    document.querySelectorAll('.completed-task').forEach(task => {
                        task.style.display = '';
                    });
                } else {
                    setCookie(filter, false);
                    document.querySelectorAll('.completed-task').forEach(task => {
                        task.style.display = 'none';
                    });
                }
            });
        });
    }
    
    document.querySelectorAll('.task-client').forEach(element => {
        element.style.display = 'none';
    });
    
    blurToCurrency(0, [
        '#client_buyerBudget',
        '#client_sellerBudget'
    ]);
    blurToPercentage(0, [
        '#client_buyerProbability',
        '#client_sellerProbability'
    ]);
    
    // REPLACED: TokenInput replaced with Tom Select Stimulus controller
    // Token fields now use data-controller="tom-select" in the HTML
    
    // Character limit functionality now handled by Stimulus character_limit_controller
    // Applied via data-controller="character-limit" in the HTML forms
    
    addOrRemoveFields();
}